import React, { useState } from 'react';
import { Form, Input, Button, Alert } from 'antd';
import { useTranslation } from 'react-i18next';
import { useNavigate, useParams } from 'react-router-dom';
import './Login.css';
import { useAuthStore } from '../../store/authUserStore';

const ResetPassword: React.FC = () => {
    const [form] = Form.useForm();
    const { id } = useParams<{ id: string }>();
    const [resetToken, setResetToken] = useState(id);
    const [newPassword, setNewPassword] = useState('');
    const resetPassword = useAuthStore((state) => state.resetPassword);
    const error = useAuthStore((state) => state.error);
    const isLoading = useAuthStore((state) => state.isLoading);
    const navigate = useNavigate();
    const { t } = useTranslation();

    const handleSubmit = async (values: { resetToken: string, newPassword: string }) => {
        const { resetToken, newPassword } = values;
        await resetPassword(resetToken, newPassword);
        if (!error) {
            navigate('/');
        }
    };

    return (
        <div className="login-bg">
            <div className="login-container">
                <div className="login-card">
                    <div className="login-logo">
                        <img src="/logo.png" alt="Logo" />
                    </div>
                    <h2 className="login-title">{t('general.resetPassword')}</h2>

                    <Form
                        form={form}
                        autoComplete='off'
                        autoCorrect='off'
                        onFinish={handleSubmit}
                        layout="vertical"
                        initialValues={{ resetToken, newPassword }}
                        size="large"
                        className="login-form"
                    >
                        <Form.Item
                            label={t('general.resetToken')}
                            name="resetToken"
                            rules={[
                                { required: true, message: t('general.resetPasswordResetTokenRequired') }
                            ]}
                            hidden={true}
                        >
                            <Input
                                value={resetToken}
                                onChange={e => setResetToken(e.target.value)}
                                className="login-input"
                                placeholder={t('general.resetToken')}
                                autoComplete="off"
                            />
                        </Form.Item>
                        <Form.Item
                            label={t('general.newPassword')}
                            name="newPassword"
                            rules={[
                                { required: true, message: t('general.resetPasswordNewPasswordRequired') }
                            ]}
                        >
                            <Input.Password
                                value={newPassword}
                                onChange={e => setNewPassword(e.target.value)}
                                className="login-input"
                                placeholder={t('general.newPassword')}
                            />
                        </Form.Item>
                        {error && (
                            <Form.Item>
                                <Alert message={error} type="error" showIcon />
                            </Form.Item>
                        )}
                        <Form.Item>
                            <Button
                                type="primary"
                                htmlType="submit"
                                loading={isLoading}
                                className="login-button"
                                block
                            >
                                {t('general.submit')}
                            </Button>
                        </Form.Item>
                    </Form>

                </div>
            </div>
        </div>
    );
};

export default ResetPassword;
